import styled from "styled-components";

export const TodayWeatherContainer = styled.div`
    font-family: S-Core-Dream;

    .titleLb {
        color: #212529;
        font-size: 24px;
        font-weight: 600;
    }

    .locationRow {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 12px;
        margin-bottom: 8px;
    }

    .locationSelect {
        flex: 1;
        height: 40px;
        padding: 0 12px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 14px;
        font-family: S-Core-Dream;
        background: #fff;
        color: #495057;
        outline: none;
        cursor: pointer;
        box-sizing: border-box;
        transition: border-color 0.2s;
        &:focus { border-color: #86b7fe; }
    }

    .settingBtn {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
        img { width: 20px; height: 20px; }
    }

    .todayDiv {
        height: 130px;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        align-items: center;
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        margin: 12px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        padding: 0 4px;

        &::-webkit-scrollbar {
            height: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ced4da;
            border-radius: 4px;
        }
    }

    .weekDiv {
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        margin: 12px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        padding: 8px 0;

        > div {
            width: 100%;
            height: 32px;
            display: flex;
            margin: 8px 0;
            padding: 0 12px;
            align-items: center;
            box-sizing: border-box;

            > label {
                width: 10%;
                padding: 0 4px;
                font-family: "Roboto";
                font-size: 14px;
                color: #495057;
            }
            > label:nth-child(1) {
                width: 30%;
                font-family: S-CORE-DREAM;
                font-size: 14px;
                font-weight: 500;
                color: #212529;
            }
            img { width: 28px; }
        }
    }

    .todayItemDiv {
        div {
            width: 60px;
            > label:nth-child(1) {
                font-size: 11px;
                font-family: 'S-CORE-DREAM';
                color: #6c757d;
            }
        }
        font-family: "Roboto";
        padding: 0px 2px;
        color: #212529;
        img { width: 32px; }
    }

    .topTxt { font-size: 10px; vertical-align: top; }

    .blueCor {
        border-radius: 50%;
        background-color: rgba(13,110,253,0.15);
        color: #0d6efd;
        width: 24px;
        display: inline-block;
        font-weight: 600;
    }
    .redCor {
        background-color: rgba(220,53,69,0.15);
        color: #dc3545;
        border-radius: 50%;
        width: 24px;
        display: inline-block;
        font-weight: 600;
    }

    .loadingMap {
        display: flex;
        position: fixed;
        top: 0; left: 0;
        align-items: center;
        height: 100%; width: 100%;
        z-index: 200;
        background: rgba(0,0,0,0.3);
        span {
            width: 100%;
            background: rgba(255,255,255,0.95);
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: S-Core-Dream;
            font-weight: 600;
            font-size: 18px;
            color: #333;
        }
    }
`;
